import ApplicationSerializer from './application';

export default class SummaryAttributeSerializer extends ApplicationSerializer {
  attrs = {
    image: {
      serialize: false,
    },
    state: {
      serialize: false,
    },
    messageHtml: {
      serialize: false,
    },
    defaultMessage: {
      serialize: false,
    },
  };
}
